import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { UnassignedShiftsDispatch } from './reducers/unassignedShifts'
import unassignedShiftsReducer, {
  UnassignedShiftsState,
  initialUnassignedShiftsState,
} from './reducers/unassignedShifts'

type Context = [UnassignedShiftsState, UnassignedShiftsDispatch]

const { context: UnassignedShiftsContext, hook: useUnassignedShifts } = createContext<Context>()

const UnassignedShiftsProvider = ({ children }: React.PropsWithChildren) => {
  const memoizedReducer = useCallback(unassignedShiftsReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialUnassignedShiftsState())

  return (
    <UnassignedShiftsContext.Provider value={[state, dispatch]}>
      {children}
    </UnassignedShiftsContext.Provider>
  )
}

export { UnassignedShiftsProvider, useUnassignedShifts }
